import type { ReactNode } from 'react'
import { useLocation } from 'react-router'

import { ProductBlankState } from '@/components/sidebar'
import { SidebarTab } from '@/lib/sidebarTab'
import { useCurrentUser } from '@/models/user'
import { Container } from '../../../components/Container'
import { InsuranceOffer } from './InsuranceOffer'
import { useActiveSidebarTab } from './sidebar/ActiveSidebarTab'
import { BOOKKEEPER_BLANK_STATE, isProductOffer } from './sidebar/navigation'

/** The route's page, covered by its offer when the tab picked is a product the fleet has not bought. */
export function TabPage({ children }: { children: ReactNode }) {
  const { user } = useCurrentUser({ enabled: false })
  const { tab, picked } = useActiveSidebarTab()
  const { pathname } = useLocation()

  const offer = !!user && isProductOffer(tab, user, pathname, picked)

  return (
    <>
      {/* One place in the tree either way: a pick is no navigation, so the page and its unsaved edits stay mounted. */}
      <div hidden={offer} className={offer ? undefined : 'contents'}>
        {children}
      </div>
      {offer && (
        <Container className="flex flex-1 flex-col pb-6">
          {tab === SidebarTab.Insurance ? (
            <InsuranceOffer />
          ) : (
            <ProductBlankState {...BOOKKEEPER_BLANK_STATE} />
          )}
        </Container>
      )}
    </>
  )
}
